export default __webpack_public_path__ + "assets/ico_empty_contract-1f664c19.svg";